import React from 'react';
import {useDispatch} from 'react-redux';

import {ROUTE, MODE} from 'containers/App/constants';
import {List} from 'components';

import {WisbitItem} from './types';
import i18n from 'i18next';
import {push} from 'connected-react-router';

type WisbitListProps = {
  data?: WisbitItem[];
  className?: string;
};

function WisbitList({data, className}: WisbitListProps) {
  const dispatch = useDispatch();

  const items = data
    ? data.map(
        ({
          id,
          thumbnailImageData,
          title,
          published,
          students,
          contentCreator,
        }) => ({
          id,
          icon: thumbnailImageData,
          title,
          subtitle: `${contentCreator} | ${i18n.t(
            'manageWisbitPage.wisbitList.subtitleLabel',
            {
              count: students,
            }
          )}`,
          flag: published
            ? i18n.t('manageWisbitPage.wisbitList.published')
            : undefined,
          onClick: () => {
            dispatch(
              push(
                `${ROUTE.Wisbit.Index}/${id}/${
                  published ? MODE.VIEW : MODE.EDIT
                }`
              )
            );
          },
        })
      )
    : [];

  return (
    <div className={`overflow-auto h-full-24 ${className || ''}`}>
      <div className="w-7/12 m-auto">
        <List className="w-full py-2">
          {items.map(item => (
            <List.Item data={item} key={item.id} />
          ))}
        </List>
      </div>
    </div>
  );
}

export default WisbitList;
